import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-white" id="faq">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-14">
          <p className="text-[10px] font-medium text-stone-400 uppercase tracking-[0.2em] mb-3">帮助中心</p>
          <h2 className="text-3xl md:text-4xl font-[family-name:var(--font-heading)] text-stone-800">
            常见问题
          </h2>
          <p className="mt-3 text-stone-400 text-sm">关于韩漫屋，您可能想了解的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="border border-stone-200 rounded-xl overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-stone-50 transition-colors"
              >
                <h3 className="text-sm font-medium text-stone-800 pr-4">{faq.question}</h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-stone-400"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 pb-5 px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-stone-500 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}